<template>
  <div>
    <app-header title=""></app-header>

    <div class="container my-5">
      <h2>
        <template v-if="financialTarget.id">
          {{ financialTarget.financial_year_start | moment('DD/MM/YYYY') }} - {{ financialTarget.financial_year_end | moment('DD/MM/YYYY') }}
        </template>
      </h2>

      <div class="card mb-4">
        <div class="card-body">
          <h3>Financial Year Target</h3>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="control-label">Financial Year Start</label>
              <datepicker v-model="financialTarget.financial_year_start" input-class="form-control" format="dd/MM/yyyy" :disabled="!isAdmin"></datepicker>
            </div>
            <div class="col-md-6 mb-3">
              <label class="control-label">Financial Year End</label>
              <datepicker v-model="financialTarget.financial_year_end" input-class="form-control" format="dd/MM/yyyy" :disabled="!isAdmin"></datepicker>
            </div>
            <div class="col-md-6 col-lg-4 mb-3">
              <label class="control-label">Revenue</label>
              <input type="number" class="form-control" v-model="financialTarget.revenue" :readonly="!isAdmin" />
            </div>
            <div class="col-md-6 col-lg-4 mb-3">
              <label class="control-label">Profit</label>
              <input type="number" class="form-control" v-model="financialTarget.profit" :readonly="!isAdmin" />
            </div>
            <div class="col-md-6 col-lg-4 mb-3">
              <label class="control-label">Sales</label>
              <input type="number" class="form-control" v-model="financialTarget.sales" :readonly="!isAdmin" />
            </div>
          </div>

          <h3 class="mt-3">Category Revenue Targets</h3>
          <div class="row">
            <div class="col-md-6 col-lg-3 mb-3">
              <label class="control-label">Development</label>
              <input type="number" class="form-control" v-model="financialTarget.development" :readonly="!isAdmin" />
            </div>
            <div class="col-md-6 col-lg-3 mb-3">
              <label class="control-label">Scoping</label>
              <input type="number" class="form-control" v-model="financialTarget.scoping" :readonly="!isAdmin" />
            </div>
            <div class="col-md-6 col-lg-3 mb-3">
              <label class="control-label">SLA</label>
              <input type="number" class="form-control" v-model="financialTarget.sla" :readonly="!isAdmin" />
            </div>
            <div class="col-md-6 col-lg-3 mb-3">
              <label class="control-label">DevOps</label>
              <input type="number" class="form-control" v-model="financialTarget.devops" :readonly="!isAdmin" />
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col">
              <p class="mb-0">
                <span class="strong">Category Total:</span> ${{ categoryTotal | currency }}
              </p>
            </div>
            <div v-if="isAdmin" class="col-auto">
              <c-button @click="updateFinancialTarget" class="btn btn-rounded btn-primary">Save</c-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { user } from 'mixins'
import { notify } from 'utils'
import Datepicker from 'vuejs-datepicker'
import FinancialTarget from './../../models/financial-target.js'

export default {
  mixins: [user],

  components: {
    Datepicker
  },

  data () {
    return {
      financialTarget: new FinancialTarget()
    }
  },

  created () {
    this.fetchData()
  },

  computed: {
    ...mapState('user', ['authorized']),

    categoryTotal () {
      return (parseInt(this.financialTarget.development) || 0)
        + (parseInt(this.financialTarget.scoping) || 0)
        + (parseInt(this.financialTarget.sla) || 0)
        + (parseInt(this.financialTarget.devops) || 0)
    }
  },

  methods: {
    fetchData () {
      return client({ path: '/financial-targets/' + this.$route.params.financial_target_id }).then((response) => {
        this.financialTarget = response.entity
      })
    },

    updateFinancialTarget () {
      const entity = {
        ...this.financialTarget,
        financial_year_start: moment(this.financialTarget.financial_year_start).format('YYYY-MM-DD'),
        financial_year_end: moment(this.financialTarget.financial_year_end).format('YYYY-MM-DD')
      }

      return client({ path: '/financial-targets/' + this.$route.params.financial_target_id, entity, method: 'PUT' }).then(
        (response) => {
          this.financialTarget = response.entity
          notify.success('Financial target updated')
        },
        () => {
          notify.error('Failed to update financial target. Please try again.')
        }
      )
    }
  }
}
</script>

<style scoped>
.vdp-datepicker >>> .form-control[readonly] {
  background-color: #fff;
}
</style>
